<template>
  <div v-if="isUserLoggedIn" class="d-flex">
    <NavigationDrawer
      :visible="isNavBarVisible"
      @hide="isNavBarVisible = false"
    />

    <TopBar
      @openSearch="isSearchActive = true"
      @toggleNavBar="isNavBarVisible = !isNavBarVisible"
    />

    <v-main>
      <router-view></router-view>
    </v-main>

    <SearchResults :visible="isSearchActive" @close="isSearchActive = false" />

    <ModalDispatcher :type="modals.type" :props="modals.props" />

    <TaskCreatorDrawer />
    <TaskEditorDrawer />
    <EntityDrawer />
    <AiAssistantDialog v-if="aiFeaturesAreEnabled" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import access from '@/lib/access'

import ModalDispatcher from '@/containers/ModalDispatcher.vue'
import SearchResults from '@/components/Core/Search/SearchResults.vue'
import NavigationDrawer from '@/App/NavigationDrawer.vue'
import TopBar from '@/App/TopBar.vue'
import TaskCreatorDrawer from '@/components/Tasks/TaskCreatorDrawer.vue'
import TaskEditorDrawer from '@/components/Tasks/TaskEditorDrawer.vue'
import EntityDrawer from '@/components/EntityDrawer/EntityDrawer.vue'
import AiAssistantDialog from '@/components/AiAssistant/AiAssistantDialog.vue'

export default {
  name: 'DefaultLayout',

  components: {
    NavigationDrawer,
    ModalDispatcher,
    TopBar,
    SearchResults,
    TaskCreatorDrawer,
    TaskEditorDrawer,
    EntityDrawer,
    AiAssistantDialog,
  },

  data() {
    return {
      isNavBarVisible: !this.$vuetify.breakpoint.mobile,
      isSearchActive: false,
      alertData: {
        status: false,
        type: '',
        message: '',
      },
    }
  },
  computed: {
    ...mapState('modals', {
      modals: state => state,
    }),

    ...mapGetters(['account', 'organization']),

    isUserLoggedIn() {
      return access.isLoggedIn()
    },

    aiFeaturesAreEnabled() {
      return access.aiFeaturesAreEnabled(this.account, this.organization)
    },
  },
}
</script>
